// The sites CSV upload's client-side header check, normalised the way the BACKEND parser
// normalises (sites.service.ts parseSitesCsv): a leading BOM is stripped, headers are trimmed and
// lower-cased, and the aliases the parser maps are folded onto the canonical names the export
// emits. Before this, the dialog compared raw headers case-sensitively, so a file Excel saved as
// "CSV UTF-8" (which adds a BOM) or one written as `Name` was rejected in the browser even though
// the backend would have accepted it, and `sub region` was reported as an unknown column. A
// quoted header line (`"name","region"`, the way pandas or LibreOffice write with quoting on) is
// unquoted the way csv-parse unquotes it; a header containing a comma is not supported here (the
// export never writes one), the server's parser remains the authority for such a file.
//
// No component or client imports, so it is unit-tested in isolation.

export const SITE_CSV_REQUIRED = ["name"] as const;
export const SITE_CSV_OPTIONAL = [
  "region",
  "subRegion",
  "group",
  "activationTime",
  "tags",
] as const;

const ALIASES: Record<string, string> = {
  name: "name",
  site: "name",
  region: "region",
  subregion: "subRegion",
  "sub region": "subRegion",
  group: "group",
  activationtime: "activationTime",
  "activation time": "activationTime",
  tags: "tags",
};

// EXACTLY the backend's alias map (parseSitesCsv) and nothing more: an alias only the client knew
// made the dialog report a column as found while the server dropped it silently.
/** Header line -> canonical column names; a header the backend does not map is returned as typed. */
export const normalizeSiteCsvHeaders = (headerLine: string): string[] =>
  headerLine
    .replace(/^\uFEFF/, "")
    .split(",")
    .map((h) => unquote(h.trim()).trim())
    .filter((h) => h.length > 0)
    .map((h) => ALIASES[h.toLowerCase()] ?? h);

/** `"Sub ""Region"""` -> `Sub "Region"`: surrounding quotes off, doubled quotes folded, as csv-parse does. */
const unquote = (h: string): string =>
  h.length >= 2 && h.startsWith('"') && h.endsWith('"')
    ? h.slice(1, -1).replace(/""/g, '"')
    : h;
